import ChefBanner from './ChefBanner';

export default ChefBanner;
